import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import trackAction from 'utils/tracking';

import NewsCard from 'components/NewsCard';
import Carousel from 'components/Core/Carousel';

const renderNewsItems = (newsItem) => {
  return (
    <div key={newsItem.url} className="h-full px-2 lg:px-3">
      <NewsCard
        onClick={() => {
          trackAction('latest-news', newsItem.shortTitle, 'article-click');
        }}
        standalone
        {...newsItem}
      />
    </div>
  );
};

const mediaQueries = {
  md: '(min-width: 768px) and (max-width: 1023px)',
  lg: '(min-width: 1024px)',
};

const LatestNews = ({ title, latestNews }) => {
  return (
    <div className="container mx-auto px-4">
      <div className="u-block-margins">
        <div className="flex items-center justify-between mb-5 lg:mb-10">
          <h2 className="h3">{title}</h2>
          <a
            onClick={() => {
              trackAction('latest-news', 'view-all-news-items', 'view-all');
            }}
            onKeyUp={(event) => {
              if (event.key === 'Enter') {
                trackAction('latest-news', 'view-all-news-items', 'view-all');
              }
            }}
            href={latestNews[0].parent.url}
            className="underline text-primary hover:text-primary-600 focus:text-primary-600"
          >
            Bekijk meer
          </a>
        </div>

        <Media queries={mediaQueries} defaultMatches={{ lg: true }}>
          {(matches) => {
            if (matches.lg) {
              return (
                <div className="flex flex-wrap lg:-mx-3">
                  {latestNews.map((newsItem) => (
                    <div key={newsItem.url} className="flex-1/3 max-w-1/3">
                      {renderNewsItems(newsItem)}
                    </div>
                  ))}
                </div>
              );
            }
            if (matches.md) {
              return (
                <Carousel
                  items={latestNews}
                  totalNumber={latestNews.length}
                  visibleSlides={2}
                  slideRenderer={renderNewsItems}
                />
              );
            }
            return <Carousel items={latestNews} totalNumber={latestNews.length} slideRenderer={renderNewsItems} />;
          }}
        </Media>
      </div>
    </div>
  );
};

LatestNews.propTypes = {
  title: PropTypes.string.isRequired,
  latestNews: PropTypes.arrayOf(NewsCard).isRequired,
};

export default LatestNews;
